export default function CarEmoji() {
    return (
      <img
        className="car-emoji"
        src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f3ce_fe0f/512.gif"
        alt="🏎️"
      />
    );
  };
